module.exports = __webpack_public_path__ + "static/media/lionfish.8c3571d0.jpg";